module.exports = __webpack_public_path__ + "img/金融服务_获嘉.2f8a6bf4.png";